module.exports = __webpack_public_path__ + "img/blue-t-shirt.59f87774.jpg";